import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {on, Options} from "../utils/decorators";
import axios from 'axios';
import {has,isObject} from "underscore";

const Weglot = (<any>window).Weglot;
const weglotKey = (<any>window).DJANGO.weglotKey;

const cache = {};

const MESSAGES = {
    LOADING: 'submitting...',
    SUCCESS_NEW: 'Thank you for joining our mailing list!',
    SUCCESS_EXISTING: 'Thank you for updating your preferences!',
    ERROR: 'Sorry an error occurred, please try again!',
};

@Options({
    template: false,
    ui: {
        signupEmailField: "[data-js-ui=signup-email]",
        signupEmailForm: "[data-js-ui=signup-form]",
    }
})

export default class EmailSignupView extends Marionette.View<Backbone.Model> {

    @on('submit @ui.signupEmailForm')
    onEmailSubmit(e) {
        e.stopPropagation();

        const form = $(this.el).find('form');
        let messages = $(this.el).find('.wrapper__mailing-messages');

        if(!messages.length) {
            messages = $(this.el).find('.sign-up-form__messages');
        }

        const url = form.attr('data-action-root');
        const email = form.find('[name="email"]').val().toString();
        let successMessageNew = this.el.attributes.getNamedItem('data-success-new-message') && this.el.attributes.getNamedItem('data-success-new-message').value ?
            this.el.attributes.getNamedItem('data-success-new-message').value :
            MESSAGES.SUCCESS_NEW;
        this.doTranslate(successMessageNew).then(translation => {
                        if (!translation) {
                            return;
                        }

                        successMessageNew = translation;

                    });
        let successMessageExisting = this.el.attributes.getNamedItem('data-success-existing-message') && this.el.attributes.getNamedItem('data-success-existing-message').value ?
            this.el.attributes.getNamedItem('data-success-existing-message').value :
            MESSAGES.SUCCESS_EXISTING;
        this.doTranslate(successMessageExisting).then(translation => {
                        if (!translation) {
                            return;
                        }

                        successMessageExisting = translation;

                    });

        let errorMessage = this.el.attributes.getNamedItem('data-error-message') && this.el.attributes.getNamedItem('data-error-message').value ?
            this.el.attributes.getNamedItem('data-error-message').value :
            MESSAGES.ERROR;
            this.doTranslate(errorMessage).then(translation => {
                        if (!translation) {
                            return;
                        }

                        errorMessage = translation;

                    });
        const data = {
            'email': email,
            'customer_contact_point_purposes': form.find('[name="customer_contact_point_purposes"]').val().toString(),
        };

        this.el.classList.add('loading');
        messages.html(`<p>${MESSAGES.LOADING}</p>`);

        axios.post(url, data, {withCredentials: true}).then(response => {
            this.el.classList.remove('loading')
            this.el.classList.add('loaded');
            if (response.data.error) {
                messages.html(`<p>${response.data.description}</p>`);
            } else if(response.data && response.data.data.new_user) {
                messages.html(`<p>${successMessageNew}</p>`);
            } else {
                messages.html(`<p>${successMessageExisting}</p>`);
            }
        }).catch(err => {
            console.error('error submitting subscription', err, this);
            this.el.classList.remove('loading');
            this.el.classList.add('error');
            if (err.data && err.data.description) {
                messages.html(`<p>${err.data.description}</p>`);
            } else {
                messages.html(`<p>${errorMessage}</p>`);
            }
        });
        return false;
    }

    hashKey(string) {
        let hash = 0, i = 0, len = string.length;
        while ( i < len ) {
            hash  = ((hash << 5) - hash + string.charCodeAt(i++)) << 0;
        }
        return hash
    }
    getItem(key) {
        const item = localStorage.getItem(key);

        try {
            return JSON.parse(item);
        } catch(e) {
            return null;
        }
    }

    doTranslate(words) {
        const ttl = 300 * 1000;
        const time = Date.now();

        const langTo = Weglot.getCurrentLang();
        const langFrom = Weglot.options.language_from;

        const key = langTo + this.hashKey(words);

        if (key in cache) {
            return cache[key];
        }

        let cached = this.getItem(key);

        let translation = null;

        if (!cached) {
            translation = this.postRequest(langTo, langFrom, words);

            cache[key] = translation.then(response => {
                if (!response) {
                    return null;
                }

                localStorage.setItem(key, JSON.stringify({
                    value: response,
                    expiry: time + ttl,
                }));

                return response;
            });
        } else {
            if (cached.expiry < time) {
                translation = this.postRequest(langTo, langFrom, words);

                translation.then(response => {
                    if (!response) {
                        return null;
                    }

                    localStorage.setItem(key, JSON.stringify({
                        value: response,
                        expiry: time + ttl,
                    }));

                    return response;
                });
            }

            const deferred = $.Deferred();

            deferred.resolve(cached.value);

            cache[key] = deferred.promise();
        }

        return cache[key];
    }
    postRequest(langTo, langFrom, words) {
        const options = {
            method: 'POST',
            url: 'https://api.weglot.com/translate?api_key=' + weglotKey,
            data: {
                l_to: langTo,
                l_from: langFrom,
                words: [
                    {
                        w: words,
                        t: 1,
                    },
                ],
                request_url: location.href,
            },
        }

        return axios(options).then(response => {
            const data = response.data;

            if (isObject(data) === false) {
                return null;
            }

            if (has(data, 'to_words') === false || data.to_words.length === 0) {
                return null;
            }

            return data.to_words[0];
        });
    }
}



// WEBPACK FOOTER //
// ./@modules/views/email-signup-view.ts